import api from './api';

export async function getDepartments() {
  const { data } = await api.get('/department');
  return data;
}

export async function createDepartment(payload) {
  const { data } = await api.post('/department', payload);
  return data;
}

export async function updateDepartment(id, payload) {
  const { data } = await api.put(`/department/${id}`, payload);
  return data;
}

export async function changeDepartmentState(id) {
  const { data } = await api.get(`/department/change-state/${id}`);
  return data;
}

export async function deleteDepartment(id) {
  const { data } = await api.delete(`/department/${id}`);
  return data;
}

export async function getProductTypes() {
  const { data } = await api.get('/product-type');
  return data;
}

export async function createProductType(payload) {
  const { data } = await api.post('/product-type', payload);
  return data;
}

export async function updateProductType(id, payload) {
  const { data } = await api.put(`/product-type/${id}`, payload);
  return data;
}

export async function changeProductTypeState(id) {
  const { data } = await api.get(`/product-type/change-state/${id}`);
  return data;
}

export async function deleteProductType(id) {
  const { data } = await api.delete(`/product-type/${id}`);
  return data;
}

export async function getProductUses() {
  const { data } = await api.get('/product-use');
  return data;
}

export async function createProductUse(payload) {
  const { data } = await api.post('/product-use', payload);
  return data;
}

export async function updateProductUse(id, payload) {
  const { data } = await api.put(`/product-use/${id}`, payload);
  return data;
}

export async function changeProductUseState(id) {
  const { data } = await api.get(`/product-use/change-state/${id}`);
  return data;
}

export async function deleteProductUse(id) {
  const { data } = await api.delete(`/product-use/${id}`);
  return data;
}
